import React from 'react';
import _ from 'lodash';

import ReactMarkdown from 'react-markdown/with-html';

const ChinaFooterTemplate = props => {
    const { data, language } = props;
    const home = _.get(data, 'home');

    return (
        <footer className="chinaFooter inverse">
            <div className="container">
                <div className="chinaFooter__blurb col-12 col-md-8 col-lg-4">
                    <div className="chinaFooter__text text-center">
                        {home.footerBlurb && <ReactMarkdown source={home.footerBlurb[language]} />}
                    </div>
                </div>

                <div className="chinaFooter__grid grid text-center">
                    <div className="col-12 col-lg-6">
                        {home.address1 && <ReactMarkdown source={home.address1[language]} />}
                    </div>
                    <div className="col-12 col-lg-6">
                        {home.address2 && <ReactMarkdown source={home.address2[language]} />}
                    </div>
                </div>
            </div>
        </footer>
    )
};

export default ChinaFooterTemplate;